import {Controller} from '@stubhub/react-store-provider';

import {isLoadingSelector, currencySelector, priceSelector} from './selectors';

const controller = new Controller({
  namespace: 'currencyExchange',
  mapStateToProps: (state = {}, ownProps) => ({
    isDataLoading: isLoadingSelector(state, ownProps),
    exchangeCurrency: currencySelector(state, ownProps),
    exchangePrice: priceSelector(state, ownProps),
  }),
});

export default controller;
